import { render, staticRenderFns } from "./SearchRegistration.vue?vue&type=template&id=1ce7015f"
import script from "./SearchRegistration.vue?vue&type=script&lang=js"
export * from "./SearchRegistration.vue?vue&type=script&lang=js"
import style0 from "./SearchRegistration.vue?vue&type=style&index=0&id=1ce7015f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports